var ServicesPage = function () {
    var _template = 'services';

    var _enableSlider = function () {

        if (typeof $.fn.slick != "function") {
            return;
        }

        var $slider = $('.slides'),
            $sliderNextBtn = $(".slides__btn_next"),
            $sliderPrevBtn = $(".slides__btn_prev");

        $slider.on('init', function(slick) {
            tm.to($slider, 0.8, {css:{y:0, opacity:1}, delay: 0.4});
            tm.to($sliderNextBtn, 0.4, {css:{opacity:0.8}, delay: 1});
            tm.to($sliderPrevBtn, 0.4, {css:{opacity:0.8}, delay: 1});
            App.onResize();
        });

        $slider.slick({
            lazyLoad: 'progressive',
            dots: true,
            autoplay: true,
            autoplaySpeed: 3000,
            arrows: false,
            speed: 1500,
            easing: 'easeInOutCirc'
        });

        $sliderNextBtn.on('click', function(){
            $slider.slick('slickNext');
        });

        $sliderPrevBtn.on('click', function(){
            $slider.slick('slickPrev');
        });

        // hide prev/next arrows if the slider have only one slide
        if ($slider.find('a').length == 1) {
            tm.to($sliderNextBtn, 0.2, {autoAlpha:0});
            tm.to($sliderPrevBtn, 0.2, {autoAlpha:0});
        }
    };

    var _disableSlider = function () {
        var $slider = $('.slides');
        if (typeof $.fn.slick != "function") {
            return;
        }
        $slider.slick('unslick');
    };

    var _enableEventHandlers = function() {
        // _enableSlider();

        $('.viewport').on('inview', function() {
            var $banner = $(this).find('.banner__wrap'),
                $headline = $(this).find('#headline'),
                $bodycopy = $(this).find('.bodycopy'),
                $form = $(this).find('.enquiry_panel');

            tm.to($banner, 0.6, {y: 0, opacity: 1, ease: Circ.easeOut, delay: 0.2});
            tm.to($headline, 1, {x: 0, opacity: 1, ease: Circ.easeOut, delay: 0.6});
            tm.to($bodycopy, 1, {y: 0, opacity: 1, ease: Circ.easeOut, delay: 0.8});
            tm.to($form, 1, {y: 0, opacity: 1, ease: Circ.easeOut, delay: 0.8});
            // tm.staggerTo($sharers, 0.5, {x: 0, opacity: 1, ease: Circ.easeOut, delay: 0.4}, 0.2);
        });

        $('.enquiry_panel').on('inview', function() {
            tm.to($(this), 0.6, {y: 0, opacity: 1, ease: Circ.easeOut, delay: 0.8});
        });

        $('.case_studies_panel').on('inview', function() {
            tm.to($(this), 0.6, {y: 0, opacity: 1, ease: Circ.easeOut, delay: 1});
        });

        $('.sidebar_free_quote').on('inview', function() {
            tm.to($(this), 0.6, {y: 0, opacity: 1, ease: Circ.easeOut, delay: 1.2});
        });

        $(window).on("scroll resize", inview);
        setTimeout(inview, 1);
    };
    var _disableEventHandlers = function() {
        // _disableSlider();

        $('.viewport').off('inview', function() {
            var $banner = $(this).find('.banner__wrap'),
                $headline = $(this).find('#headline'),
                $bodycopy = $(this).find('.bodycopy'),
                $form = $(this).find('.enquiry_panel');

            tm.to($banner, 0.6, {y: 0, opacity: 1, ease: Circ.easeOut, delay: 0.2});
            tm.to($headline, 1, {x: 0, opacity: 1, ease: Circ.easeOut, delay: 0.6});
            tm.to($bodycopy, 1, {y: 0, opacity: 1, ease: Circ.easeOut, delay: 0.8});
            tm.to($form, 1, {y: 0, opacity: 1, ease: Circ.easeOut, delay: 0.8});
            // tm.staggerTo($sharers, 0.5, {x: 0, opacity: 1, ease: Circ.easeOut, delay: 0.4}, 0.2);
        });

        $(window).off("scroll resize", inview);
    };

    return {
        animateIn: function(callback) {
            if ($('.viewport').data('template') != _template) {
                return false;
            }

            _enableEventHandlers();

            tm.to($('.page-row-expanded'), 0.3, {css:{opacity: 1}, onComplete: function() {
                if (callback && typeof(callback) === "function") {
                    return(callback());
                }
            }});
        },
        animateOut: function(callback) {
            if ($('.viewport').data('template') != _template) {
                return false;
            }
            _disableEventHandlers();

            var $banner = $('.banner__wrap'),
                $headline = $('#headline'),
                $bodycopy = $('.bodycopy'),
                $form = $('.enquiry_panel');

            tm.to($form, 0.5, {y: 20, opacity: 0, ease: Circ.easeOut, delay: 0});
            tm.to($bodycopy, 0.5, {y: 60, opacity: 0, ease: Circ.easeOut, delay: 0});
            tm.to($headline, 1, {x: -30, opacity: 0, ease: Circ.easeOut, delay: 0.1});
            tm.to($banner, 0.3, {y: -20, opacity: 0, ease: Circ.easeOut, delay: 0.1, onComplete: function() {
                tm.to($('.page-row-expanded'), 0.1, {css:{opacity: 0}, onComplete: function() {
                    if (callback && typeof(callback) === "function") {
                        return(callback());
                    }
                }});
            }});
        }
    };
}();